import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-boq-report',
  templateUrl: './boq-report.component.html',
  styleUrls: ['./boq-report.component.scss']
})
export class BOQReportComponent implements OnInit {

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;

  ngOnInit() {
    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Month Wise', routerLink: `/${parentRoute}/report/boq/boq-month-wise`},
          { label: 'District Wise', routerLink: `/${parentRoute}/report/boq/boq-district-wise` },
          { label: 'MI Type', routerLink: `/${parentRoute}/report/boq/boq-mi-type` },
          { label: 'Vendor Wise',routerLink: `/${parentRoute}/report/boq/boq-vendor-wise` },
          
        ];
      }
      );
  }


}
